"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptRequestAbstract = void 0;
var request_1 = __importDefault(require("../request"));
var helper_1 = require("../../../core/helper");
var EncryptRequestAbstract = /** @class */ (function () {
    function EncryptRequestAbstract() {
    }
    // public abstract setBaseUrl(url: string): void;
    EncryptRequestAbstract.prototype.load = function (params, decrpytCallback) {
        return request_1.default.load(params, decrpytCallback);
    };
    EncryptRequestAbstract.prototype.setBaseUrl = function (url) {
        (0, helper_1.setBaseUrl)(url);
    };
    return EncryptRequestAbstract;
}());
exports.EncryptRequestAbstract = EncryptRequestAbstract;
